import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';

import { AuthService } from '../services/auth.service';

export const loginGuard: CanActivateFn = () => {
  const router = inject(Router);
  const auth = inject(AuthService);

  return auth.isAuthenticated.pipe(take(1), map(isAuth => {
    if (isAuth) {
      router.navigate(['/dashboard']);
    }
    return !isAuth;
  }));
};
